import styled from "styled-components";
import { Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        // border-right: 1px solid white;
        // border-bottom: 1px solid white;
        // color: white;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }
`;

export const GridWrapper = styled.div`
    height: 80vh;
    font-family: Roboto;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .rccap-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .rccap-list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .rccap-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
    }

    .rccap-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            .totals {
                font-weight: 600;
                background-color: #ddd;
            }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }
        }
    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }
    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }
    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }
    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }
    .active {
        color: cornflowerblue;
    }
`;